import nodeLabelCases from '../constants/nodeLabelCases';

// eslint-disable-next-line complexity
function nodeMatchesLabelCase(node, labelCase) {
    return (
        labelCase.nodeTypes.includes(node.description) &&
        (!labelCase.state || labelCase.state === node.state)
    );
}

export function getTranslationKeyForNode(node) {
    const labelCase = nodeLabelCases.find((x) => nodeMatchesLabelCase(node, x));
    return labelCase?.translationKey ?? 'Missing Translation';
}
